{
  "defaultTitle": "ไม่สามารถเช็กอินได้",
  "defaultMessage": "โปรดยืนยันข้อมูลกับผู้จัดการเดินรถของคุณ หรือติดต่อคลังสินค้า",
  "backToHomescreen": "กลับไปที่หน้าหลัก",
  "hideErrorLog": "ซ่อนบันทึกข้อผิดพลาด",
  "viewErrorLog": "ดูบันทึกข้อผิดพลาด",
  "errorLogMessageLabel": "ข้อความ:",
  "errorLogStatusLabel": "รหัสสถานะ:",
  "unknown": "ไม่ทราบ"
}
